import { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { useModuleStatus } from '../../../../hooks/useModuleStatus'
import RectangularTabs from '../../../widgets/components/RectangularTabs'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import { sanitizeFileName } from '../../core/_util'
import { InfoCard2 } from '../../../widgets/components/UI/InfoCard2'
import { getMeetings } from '../../core/_requests'
import brandingConfig from '../../../../../config/brandingConfig'

export default function Category({
  setSidebar,
  meetingCategory,
  setMeetingCategory,
  meetingId,
  meetingType,
}: any) {
  const { formatMessage } = useIntl()
  const location = useLocation()
  const navigate = useNavigate() // Get the navigate function
  const { moduleStatus } = useModuleStatus()
  const [searchParams] = useSearchParams()
  const tab = searchParams.get('tab')
  const options = [
    {
      id: 1,
      title: 'Board Meeting',
      subTitle: formatMessage({ id: 'Meeting for Board of Directors of the company' }),
      slug: 'board-meeting',
    },
    {
      id: 2,
      title: formatMessage({ id: 'Shareholders Meeting' }),
      subTitle: formatMessage({ id: 'Meeting for the Shareholders of the company' }),
      slug: 'shareholders-meeting',
    },
    {
      id: 3,
      title: formatMessage({ id: 'Other Meeting' }),
      subTitle: formatMessage({ id: 'Any Meeting that is not board or shareholders meeting' }),
      slug: 'other-meeting',
    },
  ]
  const filteredOptions =
    moduleStatus['stakeholder'] !== false
      ? options
      : options.filter((option) => ![2].includes(option.id))

  // State for managing the selected tab
  const [selectedTab, setSelectedTab] = useState<number>(filteredOptions[0]?.id || 1)
  // Handle tab change
  const handleTabChange = (id: number) => {
    setSelectedTab(id)
    const selectedOption = options.find((option) => option.id === id)
    if (selectedOption) {
      setMeetingCategory(selectedOption.title)
      navigate(
        `${location.pathname}?tab=${selectedOption.slug.toLowerCase()}${meetingId ? `&meetingId=${meetingId}` : ''
        }`
      )
    }
  }

  useEffect(() => {
    const handleTabChange = () => {
      const selectedOption = options.find(
        (option) =>
          option.slug ===
          (meetingCategory
            ? sanitizeFileName(meetingCategory).toLowerCase()
            : tab
              ? tab
              : 'board-meeting')
      )
      if (selectedOption) {
        console.log(selectedOption)
        setSelectedTab(selectedOption.id)
        setMeetingCategory(selectedOption.title)
        navigate(
          `${location.pathname}?tab=${selectedOption.slug.toLowerCase()}${meetingId ? `&meetingId=${meetingId}` : ''
          }`
        )
      }
    }
    handleTabChange() // eslint-disable-next-line
  }, []) // eslint-disable-line react-hooks/exhaustive-deps
  const [isSchedule, setIsSchedule] = useState(false)
  const getMeetingDetails = async () => {
    try {
      const {
        data: { success, data },
      } = await getMeetings(meetingId)

      if (success) {
        setIsSchedule(data.schedule)
      }
    } catch (err) {
      console.log(err)
    }
  }
  useEffect(() => {
    if (meetingId) getMeetingDetails()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const handleOnSave = () => {
    setSidebar(2)
  }

  return (
    <>
      <div className='d-flex flex-column justify-content-between w-100 h-100'>
        <div>
          <p className='mb-4 p-0'>
            {formatMessage({ id: 'Please select the category of the Meeting you want to create' })}
          </p>

          {meetingType === 'Virtual Meeting' ? (
            <InfoCard2
              title={formatMessage({ id: 'How to Schedule Virtual Compliance Meetings?' })}
              desc={formatMessage({
                id: `Schedule virtual compliance meetings with board members and stakeholders on ${brandingConfig.brandName} by adding scheduling details, managing participants, setting the agenda, and reviewing the details. This feature ensures organized and efficient compliance management.`,
              })}
              slug={brandingConfig.helpLinks.complianceMeetingScheduleNewMeetingVirtual}
            />
          ) : (
            <InfoCard2
              title={formatMessage({ id: 'How to Schedule Physical Compliance Meetings?' })}
              desc={formatMessage({
                id: `Schedule physical compliance meetings with board members and stakeholders on ${brandingConfig.brandName} by adding venue and scheduling details, inviting attendees, setting the agenda, and reviewing the details. This feature ensures organized and efficient compliance management.`,
              })}
              slug={brandingConfig.helpLinks.complianceMeetingScheduleNewMeetingPhysical}
            />
          )}

          <RectangularTabs
            options={filteredOptions}
            selectedTab={selectedTab}
            handleTabChange={handleTabChange}
            isDisabled={tab && meetingId && isSchedule}
          />
        </div>

        <div className='d-flex flex-md-row flex-column gap-3 justify-content-end'>
          <button
            className='btn bg-light custom-button-primary text-muted fw-normal py-4 w-100 w-md-auto order-md-1 order-2'
            style={{ width: '120px' }}
            type='button'
            onClick={() => {
              navigate(`/compliance-meeting`)
            }}
          >
            <span className='indicator-label font-size-14 p-0'>
              {formatMessage({ id: 'Cancel' })}
            </span>
          </button>

          <button
            className='btn bg-primary custom-button-primary text-white fw-normal py-4 w-100 w-md-auto order-md-2 order-1'
            style={{ width: '120px' }}
            onClick={handleOnSave}
          >
            <span className='indicator-label font-size-14 p-0'>{formatMessage({ id: 'Next' })}</span>
          </button>
        </div>
      </div>
    </>
  )
}
